module.exports = __webpack_public_path__ + "static/media/img_3-7c.6f2007d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/c-2/img_3-7c.png
// module id = 658
// module chunks = 0